const FilterParameterType = {
    Value: "Value" as const,
    Variable: "Variable" as const
};

export default FilterParameterType;
